import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateIsNotPast',
})
export class DateIsNotPastPipe implements PipeTransform {
  transform(dateStr: string | Date | null | undefined): boolean {
    if (!dateStr) {
      return false;
    }

    try {
      const inputDateStr = moment.utc(dateStr).local().format('YYYY-MM-DD');
      const todayStr = moment().format('YYYY-MM-DD');
      return inputDateStr >= todayStr;
    } catch {
      return false;
    }
  }
}
